import { makeStyles, withStyles } from '@material-ui/styles'
import { Tooltip } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  field: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  item: {
    marginBottom: theme.spacing(1),
  },
  divider: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  corpoFormulario: {
    margin: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  dados: {
    padding: theme.spacing(1),
  },
  titleCampo: {
    fontSize: '15px',
    marginTop: theme.spacing(2),
  },
  cabecalhoBotao: {
    paddingRight: theme.spacing(1),
  },
  selectVisao: {
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 700,
  },
  tableRegioesSelecionadas: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  active: {},
  selectLesao: {
    width: '400px',
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  popoverSelect: {
    padding: theme.spacing(2),
  },
  tooltip: {
    marginLeft: theme.spacing(1),
  },
  contentTooltip: {
    padding: theme.spacing(2),
  },
  textTooltip: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.common.white,
    marginTop: theme.spacing(1),
  },
  caracteristicasLesao: {
    padding: theme.spacing(2),
  },
  svgWrapper: {
    padding: '7px',
  },
  gridItemFront: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    padding: '10px',
  },
  gridItemBack: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    padding: '10px',
    borderLeft: 'none',
    [theme.breakpoints.down('xs')]: {
      borderLeft: '1px solid',
      marginTop: theme.spacing(2),
    },
  },
  gridItemLeft: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    padding: '10px',
    borderTop: 'none',
    [theme.breakpoints.down('xs')]: {
      borderTop: '1px solid',
      marginTop: theme.spacing(2),
    },
  },
  gridItemRight: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    padding: '10px',
    borderTop: 'none',
    borderLeft: 'none',
    [theme.breakpoints.down('xs')]: {
      borderTop: '1px solid',
      borderLeft: '1px solid',
      marginTop: theme.spacing(2),
    },
  },
}))

export const DarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#282C33',
    color: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    minWidth: '500px',
    padding: theme.spacing(2),
    textAlign: 'justify',
  },
}))(Tooltip)
